import { useState, useEffect, useCallback } from 'react';
import { searchApi, SearchSuggestion } from '../api/search';

export const useSearchSuggestions = (query: string, delay: number = 300) => {
  const [suggestions, setSuggestions] = useState<SearchSuggestion[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSuggestions = useCallback(async (searchQuery: string) => {
    if (!searchQuery.trim() || searchQuery.trim().length < 1) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await searchApi.getSearchSuggestions(searchQuery.trim(), 8);
      if (response.success) {
        setSuggestions(response.suggestions);
      } else {
        setSuggestions([]);
      }
    } catch (err) {
      console.error('Error fetching suggestions:', err);
      setError('Failed to fetch suggestions');
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchSuggestions(query);
    }, delay);

    return () => clearTimeout(timer);
  }, [query, delay, fetchSuggestions]);

  return { suggestions, loading, error };
};
